<template>
	<view class="navbar-custom-container"> 
		<!-- #ifdef MP-WEIXIN -->
			<!-- <template v-if="headType == 'title'">
				<u-navbar :title="title" :placeholder="placeholder" :safeAreaInsetTop="safeAreaInsetTop" :fixed="fixed" :leftText="leftText" :rightText="rightText" :border="border" :bgColor="bgColor" :leftIconSize="leftIconSize" :leftIconColor="leftIconColor" :autoBack="autoBack" :titleStyle="titleStyle" @leftClick="leftClick"></u-navbar>
			</template> -->
			
			<template v-if="headType == 'title'">
				<u-navbar :title="title" :placeholder="placeholder" :safeAreaInsetTop="safeAreaInsetTop" :fixed="fixed" :leftText="leftText" :rightText="rightText" :border="border" :bgColor="bgColor" :leftIconSize="leftIconSize" :leftIconColor="leftIconColor" :autoBack="true" :titleStyle="titleStyle">
					<!-- <view class="u-nav-slot" slot="left">
						<u-icon name="arrow-left" size="19" @click="leftClick"></u-icon>
						<u-line direction="column" :hairline="false" length="16" margin="0 8px"></u-line>
						<u-icon name="home" size="20" @click="backHome"></u-icon>
					</view> -->
				</u-navbar>
			</template>
			
			<template v-if="headType == 'customLeft'">
				<u-navbar :title="title" :placeholder="placeholder" :safeAreaInsetTop="safeAreaInsetTop" :fixed="fixed" :bgColor="bgColor" :autoBack="autoBack" >
					<view slot="left">
						<slot></slot>
					</view>
				</u-navbar>
			</template>
			
			<template v-if="headType == 'customCenter'">
				<u-navbar :title="title" :placeholder="placeholder" :safeAreaInsetTop="safeAreaInsetTop" :fixed="fixed" :bgColor="bgColor" :autoBack="autoBack" >
					<view slot="center">
						<slot></slot>
					</view>
				</u-navbar>
			</template>
		<!-- #endif -->
		
		
		<!-- #ifndef MP-WEIXIN -->
		<template v-if="headType == 'title'">
			<!-- <u-navbar :title="title" :placeholder="placeholder" :safeAreaInsetTop="safeAreaInsetTop" :fixed="fixed" :leftText="leftText" :rightText="rightText" :border="border" :bgColor="bgColor" :leftIconSize="leftIconSize" :leftIconColor="leftIconColor" :autoBack="true" :titleStyle="titleStyle">
			</u-navbar> -->
		</template>
		<!-- #endif -->
	</view>
</template>

<script>
	export default {
		props: {
			title: { // 标题
				type: String,
				default: ''
			},
			autoBack: {
				type: Boolean,
				default: true
			},
			
			headType: { // 导航栏显示类型 title: 普通标题, custom: 自定义
				type: String,
				default: 'title'
			},
			
			placeholder: { // 是否生成等高的占位
				type: Boolean,
				default: true
			},
			
			safeAreaInsetTop: { // 是否开启顶部安全适配
				type: Boolean,
				default: true
			},
			
			fixed: { // 是否固定在顶部
				type: Boolean,
				default: true
			},
			
			titleWidth: { // 标题的最大宽度
				type: [String, Number],
				default: '400rpx'
			},
			
			border: { // 是否加上下边框
				type: Boolean,
				default: false
			},
			
			titleStyle: { // 字体自定义样式
				type: Object,
				default: () => {
					return {}
				}
			},
			
			leftText: { // 左边提示文字
				type: String,
				default: ''
			},
			
			rightText: { // 右边文字 - 会显示，会被默认胶囊挡住，需将胶囊屏蔽
				type: String,
				default: ''
			},
			
			bgColor: { // 背景颜色
				type: String,
				default: '#fff'
			},
			
			leftIconSize: { // 左侧返回图标的大小
				type: [String, Number],
				default: '40rpx'
			},
			
			leftIconColor: { // 左侧返回图标的颜色
				type: String,
				default: '#000'
			}
		},
		data() {
			return {
				
			}
		},
		methods: {
			// 自定义返回按钮
			leftClick() {
				let pages = getCurrentPages();
				if(pages.length <= 1) {
					uni.reLaunch({
						url: '/pages/Launch/index?name=home'
					})
				}
			},
			// 返回首页
			backHome() {
				uni.reLaunch({
					url: '/pages/Launch/index'
				})
			}
		}
	}
</script>

<style lang="scss" scoped scoped>
	.u-nav-slot {
		@include flex;
		border: 1px solid #EDEFF3;
		padding: 4rpx 12rpx;
		border-radius: 30rpx;
	}
</style>